import React from "react";
import NessunaAllerta from "../img/nessuna_allerta.png";
import AllertaGialla from "../img/allerta_gialla.png";
import AllertaArancione from "../img/allerta-arancione.png";
import AllertaRossa from "../img/allerta_rossa.png";

export default class DpcAllertaMeteo extends React.Component {

    //TODO: definire i livelli di allerta e parametrizzare immagine, titolo e testo

    getImageAllerta(statoAllerta) {
        switch (statoAllerta) {
            case '0':
                return <img src={NessunaAllerta} alt="Nessuna Allerta" className="img-fluid w-100"/>;
            case '1':
                return <img src={AllertaGialla} alt="Allerta Gialla" className="img-fluid w-100"/>;
            case '2':
                return <img src={AllertaArancione} alt="Allerta Arancione" className="img-fluid w-100"/>;
            case '3':
                return <img src={AllertaRossa} alt="Allerta Rossa" className="img-fluid w-100"/>;

        }
    }

    render() {
        return (
            <section className="container alert-meteo-idro">
                <h2 className="d-none">Allerta meteo</h2>
                <div className="px-custom">
                    <div className="alert alert-info-custom show" role="alert">
                        <div className="row">
                            <div className="col-4 col-sm-2">
                                {this.getImageAllerta(this.props.statoAllerta)}
                            </div>
                            <div className="col-8 col-sm-10">
                                <h2><a href={this.props.linkTitolo}>{this.props.title}</a></h2>
                                <div
                                    dangerouslySetInnerHTML={{__html: this.props.body ? this.props.body.processed + ' <a href="' + this.props.linkBody + '">' + this.props.titoloLinkBody + '</a>' : ''}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

}
